import { createFileRoute } from "@tanstack/react-router";
import AnthemBcbsGaInsurance, { config } from "@/pages/AnthemBcbsGaInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/anthem-bcbs-ga-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Anthem BCBS Georgia TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Anthem BCBS Georgia coverage for TMS, SAINT TMS, and SPRAVATO. Learn about prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Anthem BCBS Georgia TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Anthem BCBS Georgia coverage for TMS, SAINT TMS, and SPRAVATO. Learn about prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/anthem-bcbs-ga-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/anthem-bcbs-ga-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AnthemBcbsGaInsurance />;
}
